module.exports = __webpack_public_path__ + "static/assets/905badeeb88404dbdbd6057debe20599.gif";